An array of identifiers for the `HiringOrganization`s that have the position.

This must match the `positionOrganizations` field that was provided when creating the draft.
